import { InlineControl } from './InlineControl';
import { tableListClasses } from './TableList.classes';
import { TableListHeader } from './TableListHeader';
import { TableListProvider } from './TableListProvider';
import { TableListRow } from './TableListRow';
import { TableListStructure } from './TableListStructure';
export const TableList = {
    Provider: TableListProvider,
    Header: TableListHeader,
    Row: TableListRow,
    Structure: TableListStructure,
    InlineControl,
    classes: tableListClasses
};
